export enum DataControl {
  CHANGE,
  CLEAR,
  RESET,
}
